import styles from "./App.module.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import Navbar from "./components/Navbar/Navbar";
import Hero from "./components/Hero/Hero";
import Statistics from "./components/Statistics/Statistics";
import Fields from "./components/Fields/Fields";
import Achievements from "./components/Achievements/Achievements";
import Platform from "./components/Platform/Platform";
import CTAForm from "./components/CTAForm/CTAForm";
import TrustedSchools from "./components/TrustedSchools/TrustedSchools";
import Footer from "./components/Footer/Footer";
import AboutUs from "./components/AboutUs/AboutUs";
import SchoolProgrammes from "./components/SchoolProgrammes/SchoolProgrammes";
import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import RoboticsAI from "./components/RoboticsAI/RoboticsAI";
import ChannelPartner from "./components/ChannelPartner/ChannelPartner";
import StemCertification from "./components/StemCertification/StemCertification";
import OnlinePrograms from "./components/OnlinePrograms/OnlinePrograms";
import Shop from "./components/Shop/Shop";
import CoreTeam from "./components/CoreTeam/CoreTeam";
import WhatsAppButton from "./components/WhatsAppButton/WhatsAppButton";
import { FormProvider } from "./context/FormContext";
import AppPrivacyPolicy from "./components/AppPrivacyPolicy/AppPrivacyPolicy";

// ScrollToTop component to handle automatic scrolling
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

const HomePage = () => {
  return (
    <>
      <Hero />
      <StemCertification />
      <AboutUs />
      <Platform />
      <Achievements />
      <Fields />
      <CTAForm />
      <CoreTeam />
      <TrustedSchools />
    </>
  );
};

function App() {
  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
      mirror: false,
      offset: 100,
    });
  }, []);

  return (
    <Router>
      <FormProvider>
        <div className={styles.app}>
          <ScrollToTop />
          <Navbar />
          <CTAForm isPopup={true} />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/school-programmes" element={<SchoolProgrammes />} />
            <Route path="/online-programs" element={<OnlinePrograms />} />
            <Route path="/robotics-ai" element={<RoboticsAI />} />
            <Route path="/become-channel-partner" element={<ChannelPartner />} />
            <Route path="/products" element={<Shop />} />
            <Route path="/appprivacypolicy" element={<AppPrivacyPolicy />} />
          </Routes>
          <WhatsAppButton />
          <Footer />
        </div>
      </FormProvider>
    </Router>
  );
}

export default App;
